module.exports = __webpack_public_path__ + "static/media/DK4055_11.d14b16ba.jpg";